import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { GridRow, GridColumn, Img } from "arv-reactcomponents";
import { FAVORITESPAGE, ROUTE_PATHS, Endpoints } from "npmlinks-constants";
// import EmailSubscription from "./EmailSubscription";
// import { isApp, getBaseRouteForPath } from "../../utils";
import Anchor from "../../../component/Anchor";

@inject("FooterStore", "ProductStore")
@observer
class FavoritesEmptyState extends Component {
  constructor() {
    super();
  }

  // componentDidMount() {

  // }

  render() {
    return (
      <div className="nw-favorites-emptypage">
        <GridRow className="nw-favorites-row">
          <GridColumn className="nw-favorites-col">
            <div className="nw-favorites-container">
              <div className="nw-favorites-emptybox">
                <img
                  className="nw-favorites-emptyimg"
                  src={Endpoints.favorites_no_products}
                  alt=""
                />
              </div>
              <div className="nw-favorites-bigmsg">
                <h1 className="nw-favorites-bigmsgtag">
                  {FAVORITESPAGE.FAVORITES.EMPTY_MSG}
                </h1>
              </div>
              <div className="nw-favorites-smallmsg">
                <h5 className="nw-favorites-smallmsgtag">
                  {FAVORITESPAGE.FAVORITES.EMPTY_SUBMSG_LINE1}
                </h5>
                <h5 className="nw-favorites-smallmsgtag">
                  {FAVORITESPAGE.FAVORITES.EMPTY_SUBMSG_LINE2}
                </h5>
              </div>
              <div className="nw-favorites-shopnow">
                <Anchor.component
                  className="nw-favorites-shopbtn nwc-btn-primary"
                  to={ROUTE_PATHS.LISTING}
                  href={ROUTE_PATHS.LISTING}
                >
                  {FAVORITESPAGE.FAVORITES.SHOP_NNNOW_BTN}
                </Anchor.component>
              </div>
            </div>
          </GridColumn>
        </GridRow>
      </div>
    );
  }
}

FavoritesEmptyState.wrappedComponent.propTypes = {
  // FooterStore: PropTypes.shape({
  //   footerlinksData: PropTypes.object,
  //   footerData: PropTypes.object,
  //   getFooterLinkData: PropTypes.func,
  //   isFooterDefaultVisible: PropTypes.bool.isRequired,
  // }).isRequired,
  // ProductStore: PropTypes.shape({
  //   isHavingMoreProducts: PropTypes.bool,
  // }).isRequired,
};

const getFinalComponent = component =>
  inject("FooterStore", "ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: FavoritesEmptyState.wrappedComponent,
  component: FavoritesEmptyState,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Favorites/FavoritesEmptyState/index.js